import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-ais-locatingdevice-lost-iec')
export class ObiAisLocatingdeviceLostIec extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.09436 5.68014L4.41421 3L3 4.41421L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 13.947 4.69556 15.7316 5.85175 17.1188L3 19.9706L4.41421 21.3848L7.3142 18.4848C8.63116 19.4381 10.25 20 12 20C13.8487 20 15.551 19.3729 16.9056 18.3199L19.9706 21.3848L21.3848 19.9706L18.3199 16.9056C19.3729 15.551 20 13.8487 20 12C20 10.25 19.4381 8.63116 18.4848 7.3142L21.3848 4.41421L19.9706 3L17.1188 5.85175C15.7316 4.69556 13.947 4 12 4C10.1513 4 8.44904 4.62708 7.09436 5.68014ZM16.6022 6.36835L12.1924 10.7782L7.61307 6.19886C8.83254 5.27523 10.3523 4.72727 12 4.72727C13.7461 4.72727 15.3486 5.34265 16.6022 6.36835ZM17.8011 16.3869L13.6066 12.1924L17.9633 7.83572C18.7885 9.01533 19.2727 10.4511 19.2727 12C19.2727 13.6477 18.7248 15.1675 17.8011 16.3869ZM7.83573 17.9633L12.1924 13.6066L16.3869 17.8011C15.1675 18.7248 13.6477 19.2727 12 19.2727C10.4511 19.2727 9.01533 18.7885 7.83573 17.9633ZM6.19886 7.61307L10.7782 12.1924L6.36835 16.6022C5.34265 15.3486 4.72727 13.7461 4.72727 12C4.72727 10.3523 5.27523 8.83254 6.19886 7.61307Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.09436 5.68014L4.41421 3L3 4.41421L5.68014 7.09436C4.62708 8.44904 4 10.1513 4 12C4 13.947 4.69556 15.7316 5.85175 17.1188L3 19.9706L4.41421 21.3848L7.3142 18.4848C8.63116 19.4381 10.25 20 12 20C13.8487 20 15.551 19.3729 16.9056 18.3199L19.9706 21.3848L21.3848 19.9706L18.3199 16.9056C19.3729 15.551 20 13.8487 20 12C20 10.25 19.4381 8.63116 18.4848 7.3142L21.3848 4.41421L19.9706 3L17.1188 5.85175C15.7316 4.69556 13.947 4 12 4C10.1513 4 8.44904 4.62708 7.09436 5.68014ZM16.6022 6.36835L12.1924 10.7782L7.61307 6.19886C8.83254 5.27523 10.3523 4.72727 12 4.72727C13.7461 4.72727 15.3486 5.34265 16.6022 6.36835ZM17.8011 16.3869L13.6066 12.1924L17.9633 7.83572C18.7885 9.01533 19.2727 10.4511 19.2727 12C19.2727 13.6477 18.7248 15.1675 17.8011 16.3869ZM7.83573 17.9633L12.1924 13.6066L16.3869 17.8011C15.1675 18.7248 13.6477 19.2727 12 19.2727C10.4511 19.2727 9.01533 18.7885 7.83573 17.9633ZM6.19886 7.61307L10.7782 12.1924L6.36835 16.6022C5.34265 15.3486 4.72727 13.7461 4.72727 12C4.72727 10.3523 5.27523 8.83254 6.19886 7.61307Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-ais-locatingdevice-lost-iec': ObiAisLocatingdeviceLostIec;
  }
}
